import { setBodyClass } from '../helper/helpers';

export default class SliderFactory {
  constructor() {
    const sliders = document.querySelectorAll('.slider-teaser.brick .slider');

    sliders.forEach((slider) => new Slider(slider));
  }
}

class Slider {
  constructor(root) {
    this.root = root;
    this.slidesWrapper = root.querySelector('.slides');
    this.btnFullscreen = root.querySelector('button.fullscreen');
    this.btnFullscreenClose = root.querySelector('button.fullscreen-close');
    this.btnDots = root.querySelectorAll('button.dot');
    this.videoSlides = root.querySelectorAll('.slides .slide.video');

    this.btnPrev = root.querySelector('button.prev');
    this.btnNext = root.querySelector('button.next');

    this.index = 0;
    this.itemsCount = this.root.dataset.count;
    this.currentVideoSlide = null;
    this.currentVideo = null;

    this.slidesWrapper.style.minWidth = `${this.root.dataset.count * 100}%`;

    this.btnPrev.addEventListener('click', () => this.goTo(this.index - 1));
    this.btnNext.addEventListener('click', () => this.goTo(this.index + 1));
    this.btnDots.forEach((dot) =>
      dot.addEventListener('click', () => this.goTo(dot.dataset.index)),
    );

    this.xTouchPos = 0;

    this.btnFullscreen.addEventListener('click', () => this.openFullscreen());
    this.btnFullscreenClose.addEventListener('click', () =>
      this.closeFullscreen(),
    );

    this.root.addEventListener('touchstart', (e) => this.handleTouchStart(e));
    this.root.addEventListener('touchend', (e) => this.handleTouchEnd(e));

    window.addEventListener('keyup', (e) => this.handleKeyup(e));

    this.videoSlides.forEach((slide) => this.initVideoControls(slide));
  }

  initVideoControls(slide) {
    const btnPlay = slide.querySelector('.btn-play');
    const video = slide.querySelector('.video');

    if (!btnPlay || !video) {
      return;
    }

    btnPlay.addEventListener('click', () => {
      if (slide.classList.contains('is-playing')) {
        slide.classList.remove('is-playing');
        video.pause();
      } else {
        slide.classList.add('is-playing');
        video.play();

        this.currentVideoSlide = slide;
        this.currentVideo = video;
      }
    });
  }

  goTo(index) {
    if (index < 0 || index >= this.itemsCount) {
      return;
    }

    if (this.currentVideo) {
      this.currentVideoSlide.classList.remove('is-playing');
      this.currentVideo.pause();
    }

    this.btnDots[this.index].classList.remove('active');

    this.index = index;
    this.slidesWrapper.style.transform = `translateX(-${index * (100 / this.itemsCount)}%)`;
    this.btnDots[this.index].classList.add('active');

    if (this.index <= 0) {
      this.btnPrev.setAttribute('disabled', true);
    } else {
      this.btnPrev.removeAttribute('disabled');
    }

    if (this.index >= this.itemsCount - 1) {
      this.btnNext.setAttribute('disabled', true);
    } else {
      this.btnNext.removeAttribute('disabled');
    }
  }

  openFullscreen() {
    this.root.classList.add('fullscreen');
    setBodyClass('is-scroll-disabled', true);
  }

  closeFullscreen() {
    this.root.classList.remove('fullscreen');
    setBodyClass('is-scroll-disabled', false);
  }

  handleTouchStart(e) {
    this.xTouchPos = e.touches[0].pageX;
  }

  handleTouchEnd(e) {
    const xOffset = this.xTouchPos - e.changedTouches[0].clientX;

    if (xOffset >= 100) {
      this.goTo(this.index + 1);
    } else if (xOffset <= -100) {
      this.goTo(this.index - 1);
    }
  }

  handleKeyup(e) {
    if (!this.root.classList.contains('fullscreen')) {
      return;
    }

    switch (e.key) {
      case 'Escape':
        this.closeFullscreen();
        return;

      case 'ArrowLeft':
        this.goTo(this.index - 1);
        return;

      case 'ArrowRight':
        this.goTo(this.index + 1);
        return;
    }
  }
}
